import { ZuiBaseMixin } from '@zywave/zui-base';
import { PolymerElement, html } from '@polymer/polymer/polymer-element';
import { afterNextRender } from '@polymer/polymer/lib/utils/render-status';
import { ZuiDialogBehaviorMixin } from './zui-dialog-behavior.js';
import '@zywave/zui-icons';

class ZuiDialog extends ZuiBaseMixin(ZuiDialogBehaviorMixin(PolymerElement)) {
  static get properties() {
    return {};
  }

  constructor() {
    super();
  }

  ready() {
    super.ready();
    this.setAttribute('role', 'dialog');
    afterNextRender(this, () => {
      if (!this.noCancelOutsideDialog) {
        this.shadowRoot.getElementById('close').addEventListener('click', () => {
          this._triggerCloseEvent(false);

          this.close();
        });
      }
    });
  }

  static get template() {
    return html`
      <style>
        :host{position:fixed;top:0;right:0;bottom:0;left:0;overflow-y:auto;display:-webkit-box;display:-ms-flexbox;display:flex;padding:2em;z-index:500000;-ms-flex-direction:column}:host .wrapper{position:relative;width:100%;margin:auto;padding:1em;background-color:white;-ms-flex-negative:0;-webkit-box-shadow:rgba(0,0,0,0.14) 0px 16px 24px 2px,rgba(0,0,0,0.12) 0px 6px 30px 5px,rgba(0,0,0,0.4) 0px 8px 10px -5px;box-shadow:rgba(0,0,0,0.14) 0px 16px 24px 2px,rgba(0,0,0,0.12) 0px 6px 30px 5px,rgba(0,0,0,0.4) 0px 8px 10px -5px}:host .wrapper .x{position:absolute;top:-1.75em;right:-1.75em;cursor:pointer;color:#fff;border:none;background-color:transparent;-webkit-transition:0.2s;transition:0.2s;margin-top:0px;padding:0px}:host .wrapper .x:hover{opacity:0.7;-webkit-transition:0.2s;transition:0.2s}:host .wrapper .x button{position:relative;display:-webkit-inline-box;display:-ms-inline-flexbox;display:inline-flex;border:0;border-radius:30px;cursor:pointer;width:28px;height:28px;padding:3px;background-color:transparent;color:#fff}:host .wrapper .x button:active,:host .wrapper .x button:hover,:host .wrapper .x button:focus{outline:none;opacity:0.7;-webkit-transition:0.2s;transition:0.2s}:host .wrapper .x .icon{display:inline-block;vertical-align:top;padding:0;margin:0;height:22px;width:22px;margin-left:-1px}:host .wrapper .x .icon zui-icon{--iron-icon-height: 18px;--iron-icon-width: 18px}:host(.small) .wrapper{max-width:32em}:host(.medium) .wrapper{max-width:48em}:host(.large) .wrapper{max-width:64em}:host(.full) .wrapper{max-width:98%}:host([hide-backdrop]) .x button{border-radius:30px}:host([hide-backdrop]) .x button zui-icon{color:var(--zui-gray-600)}:host([hide-backdrop]) .x button:hover{-webkit-transition:0.2s;transition:0.2s}
      </style>
      <div id="wrapper" class="wrapper">
        <template is="dom-if" if="{{!noCancelOutsideDialog}}">
          <div class="x">
            <button id="close" aria-label="close">
              <div class="icon"> <zui-icon icon="zui-close"></zui-icon> </div>
            </button>
          </div>
        </template>
        <slot></slot>
      </div>
    `;
  }

}

customElements.define('zui-dialog', ZuiDialog);